app.controller('OrderCheckoutController',
    ['$rootScope', '$scope', '$state', '$stateParams', '$location', '$anchorScroll', '$filter',
        function ($rootScope, $scope, $state, $stateParams, $location, $anchorScroll, $filter) {

            $scope.order_id = $rootScope.model.order.current_order._id;

            function applyCheckoutState() {
                $scope.checkout_state_id = $state.$current && $state.$current.data ? $state.$current.data.checkout_state_id : null;
                if (!["review", "delivery"].includes($scope.checkout_state_id)) {
                    $scope.checkout_state_id = "submit";
                }
            }


            applyCheckoutState();
            $rootScope.$on('$stateChangeSuccess', function ($event, next, current) {
                applyCheckoutState();
            });


            $scope.currentDate = function () {
                return new Date();
            }

            const siteHelper = $rootScope.site_helper;

            $scope.invalid_reason = null;
            $scope.invalid_redirect_url = null;

            if ($rootScope.service.staff.isSelectCustomerRequired()) {
                $scope.invalid_reason = "no_customer";
            } else if (!$scope.order_id) {
                $scope.invalid_reason = "order_is_empty";
            }
            $scope.waiting_for_data = !$scope.invalid_reason;

            $scope.visible_order = null;
            $scope.user_data = null;
            $scope.customer_data = null;

            let visibleOrder = null;
            let userData = null;
            let customerData = null;
            const definedPaymentOptionIDs = ['staff', 'foc', 'payment_on_despatch', 'account', 'sagepay'];

            $scope.did_submit = false;


            function validateOrder(order) {
                $scope.invalid_reason = null;
                $scope.invalid_redirect_url = null;
                $scope.visible_order = null;
                visibleOrder = null;
                if (!order || !$rootScope.service.order_helper.isOrderWeb(order) || !$rootScope.service.account.haveMinimumData() || $scope.$$destroyed) {
                    $scope.invalid_reason = "order_not_found";
                } else if (order.lines.length === 0) {
                    $scope.invalid_reason = "order_is_empty";
                } else if (order._status === "SAGEPAY") {
                    $scope.invalid_reason = "sagepay_exit_fail";
                    $scope.invalid_redirect_url = order._redirect_url;
                } else {
                    $scope.visible_order = visibleOrder = order;
                }

            }

            if ($scope.waiting_for_data) {

                $rootScope.service.account.requireMinimumData(function () {
                    $rootScope.service.order.requestOrder($scope.order_id, function (success, order) {
                        $scope.waiting_for_data = false;
                        order = success ? order : null;
                        validateOrder(order);
                        if (!visibleOrder) {
                            return;
                        }


                        //Listen to when the cart changes an update the view
                        const unbindCurrentOrderReplaced = $rootScope.$on('current_order_replaced', function ($event, params) {
                            if ($rootScope.model.order.current_order._id === $scope.order_id) {
                                validateOrder($rootScope.model.order.current_order)
                            }
                        })
                        $scope.$on('$destroy', unbindCurrentOrderReplaced)

                        $scope.user_data = userData = $rootScope.model.account.user_data;
                        $scope.customer_data = customerData = $rootScope.model.account.customer_data;
                        populateCheckout();
                    })
                });
            }

            $scope.premiumDeliveryText = function () {
                return "<ul>" +
                    "<li>2 Person Over the Threshold to ground floor room of choice.</li>" +
                    "<li>Additional day added to delivery schedule</li>" +
                    "<li>Customer receives pre alert of delivery date.</li>" +
                    "<li>Delivery to business or home address.</li>" +
                    "<li>Remove and recycle of packaging is standard.</li>" +
                    "</ul>"
            }


            const viewModel = {
                edit_order_ref: false,
                despatch_location_ids: [],
                collection_location_ids: [],
                delivery_types: [],
                delivery_type_id: "standard",
                lead_time_option_ids: [],
                lead_time_option_id: "standard",
                payment_options: [],
                payment_option_id: null,
                confirm_delete_sagepay_token_id: null,
                recent_browse_href: null,
                checkout_adverts: [],
                force_collection_disabled_for: [],
                small_alerts: {},
                can_submit_card: false,
                can_submit_account: false,
                can_submit_order: false,
                over_credit_limit: false,
                form_disabled: false,
                selected_delivery_address: null,
                selected_invoice_address: null
            }
            $scope.view_model = viewModel;


            function populateCheckout() {

                viewModel.over_credit_limit = visibleOrder._over_credit_limit && customerData.account_type !== 'proforma' && customerData.account_type !== 'payment_on_despatch';

                populateLocations();
                populateDeliveryType();
                populateLeadTimeOption();
                populatePaymentOption();

                $rootScope.navigation_manager.requireInitialized(function () {
                    viewModel.checkout_adverts = $rootScope.service.advert.checkout_adverts(visibleOrder);
                    const recentBrowseRoute = $rootScope.service.order_helper.recentBrowseRoute(visibleOrder);
                    const recentBrowseHref = recentBrowseRoute ? $state.href(recentBrowseRoute.route, recentBrowseRoute.options) : null;
                    viewModel.recent_browse_href = recentBrowseHref ? recentBrowseHref : "/browse/overview";
                    validateCheckoutState(visibleOrder);
                });
            }

            function validateCheckoutState(order) {
                console.log("order")
                console.log(order)
                const deliveryAddressError = order._errors && order._errors.delivery_address ? order._errors.delivery_address : null;
                if (deliveryAddressError) {
                    if ($scope.checkout_state_id === "submit") {
                        $state.go('myba.order-checkout.delivery');
                    }
                }
            }

            function populateLocations() {
                viewModel.despatch_location_ids.length = 0;
                viewModel.collection_location_ids.length = 0;
                const despatchGroups = visibleOrder._despatch_groups ? visibleOrder._despatch_groups : [];
                for (let i = 0; i < despatchGroups.length; i++) {
                    const warehouse = despatchGroups[i].warehouse;
                    if (!warehouse) {
                        continue;
                    }
                    if (viewModel.despatch_location_ids.indexOf(warehouse) === -1) {
                        viewModel.despatch_location_ids.push(warehouse);
                    }
                    if (visibleOrder._collectible && !(viewModel.force_collection_disabled_for && viewModel.force_collection_disabled_for.indexOf(warehouse) !== -1) && viewModel.collection_location_ids.indexOf(warehouse) === -1) {
                        viewModel.collection_location_ids.push(warehouse);
                    }
                }
            }

            function populateDeliveryType() {

                viewModel.delivery_types = [
                    {
                        id: "standard",
                        disabled: false
                    },
                    {
                        id: "two_person_delivery",
                        disabled: false
                    },
                    {
                        id: "collection",
                        disabled: false
                    }
                ];

                if (!visibleOrder.collection && visibleOrder._requires_two_person_delivery && visibleOrder._allow_two_person_delivery) {
                    visibleOrder.two_person_delivery = true;
                }

                if (visibleOrder.collection) {
                    viewModel.delivery_type_id = "collection"
                } else if (visibleOrder.two_person_delivery) {
                    viewModel.delivery_type_id = "two_person_delivery"
                } else {
                    viewModel.delivery_type_id = "standard"
                }

                updateDeliveryType();
            }

            function updateDeliveryType() {
                let standardPersonDeliveryType, twoPersonDeliveryType, collectionDeliveryType;
                for (let i = 0; i < viewModel.delivery_types.length; i++) {
                    const deliveryType = viewModel.delivery_types[i];
                    if (deliveryType.id === "standard") {
                        standardPersonDeliveryType = deliveryType;
                    } else if (deliveryType.id === "two_person_delivery") {
                        twoPersonDeliveryType = deliveryType;
                    } else if (deliveryType.id === "collection") {
                        collectionDeliveryType = deliveryType;
                    }
                }

                standardPersonDeliveryType.disabled = visibleOrder._requires_two_person_delivery && visibleOrder._allow_two_person_delivery;
                twoPersonDeliveryType.disabled = !visibleOrder._allow_two_person_delivery;
                collectionDeliveryType.disabled = viewModel.collection_location_ids.length === 0;

                if ((viewModel.delivery_type_id === "two_person_delivery" && twoPersonDeliveryType.disabled) || (viewModel.delivery_type_id === "collection" && collectionDeliveryType.disabled)) {
                    viewModel.delivery_type_id = "standard"
                }

                visibleOrder.collection = viewModel.delivery_type_id === "collection";
                visibleOrder.two_person_delivery = viewModel.delivery_type_id === "two_person_delivery";
            }


            function populateLeadTimeOption() {
                const leadTimeOptionIDs = ['standard'];
                if (!viewModel.over_credit_limit) {
                    leadTimeOptionIDs.push('later');
                } else {
                    if (viewModel.lead_time_option_id === "later") {
                        viewModel.lead_time_option_id = "standard";
                    }
                    visibleOrder.despatch_date = null;
                }
                const despatchTypes = siteHelper.requireArray(visibleOrder._despatch_types);

                const prontofastrackAvailable = despatchTypes.indexOf('prontofastrack') !== -1;
                const fastrackAvailable = !prontofastrackAvailable && despatchTypes.indexOf('fastrack') !== -1;


                if (fastrackAvailable) {
                    leadTimeOptionIDs.push('fastrack');
                }

                if (prontofastrackAvailable) {
                    leadTimeOptionIDs.push('prontofastrack');
                }
                viewModel.lead_time_option_ids = leadTimeOptionIDs;

                visibleOrder.despatch_date = visibleOrder.despatch_type === "standard" && !!visibleOrder.despatch_date ? visibleOrder.despatch_date : null;

                if (visibleOrder.despatch_type === "standard") {
                    if (!visibleOrder.despatch_date) {
                        if (viewModel.lead_time_option_id !== "later") {
                            viewModel.lead_time_option_id = "standard";
                        }
                    } else {
                        viewModel.lead_time_option_id = "later";
                    }
                } else if ((visibleOrder.despatch_type === "fastrack" || visibleOrder.despatch_type === "prontofastrack") && leadTimeOptionIDs.indexOf(visibleOrder.despatch_type) !== -1) {
                    viewModel.lead_time_option_id = visibleOrder.despatch_type;
                } else {
                    viewModel.lead_time_option_id = "standard";
                }
                updateLeadTimeOption();
            }


            function updateLeadTimeOption() {

                if (viewModel.lead_time_option_id === 'later') {
                    visibleOrder.despatch_type = "standard";
                } else {
                    visibleOrder.despatch_type = viewModel.lead_time_option_id;
                    visibleOrder.despatch_date = null;
                }
            }


            function populatePaymentOption() {

                const paymentTypes = visibleOrder._payment_types ? visibleOrder._payment_types : [];

                const paymentOptions = [];
                let paymentOnDespatchOption = null;
                let accountOption = null;

                if ($rootScope.model.staff.is_rep) {
                    // No payment options
                } else if ($rootScope.model.staff.is_staff) {
                    if (!customerData.on_hold) {
                        paymentOptions.push({
                            id: "staff",
                            type: "staff"
                        })
                    }
                } else if (paymentTypes.indexOf("foc") !== -1) {
                    paymentOptions.push({
                        id: "foc",
                        type: "foc"
                    })
                } else {
                    if (customerData.account_type === "payment_on_despatch" && paymentTypes.indexOf("payment_on_despatch") !== -1) {
                        paymentOnDespatchOption = {
                            id: "payment_on_despatch",
                            type: "payment_on_despatch"
                        }
                        paymentOptions.push(paymentOnDespatchOption);
                    }
                    if (customerData.account_type !== "proforma" && customerData.account_type !== "payment_on_despatch") {
                        accountOption = {
                            id: "account",
                            type: "account"
                        }
                        paymentOptions.push(accountOption);
                    }
                    const sagepayTokens = userData.sagepay_tokens;
                    if (sagepayTokens) {
                        for (let sagepayTokenID in sagepayTokens) {
                            const sagepayToken = sagepayTokens[sagepayTokenID];
                            paymentOptions.push({
                                id: sagepayToken.id,
                                type: "sagepay",
                                sagepay_token: sagepayToken
                            })
                        }
                    }
                    paymentOptions.push({
                        id: "sagepay",
                        type: "sagepay"
                    })
                }
                let paymentOptionID = null;
                if (paymentOptions.length === 1) {
                    paymentOptionID = paymentOptions[0].id;
                } else if (visibleOrder.payment_type) {
                    for (let i = 0; i < paymentOptions.length; i++) {
                        const paymentOption = paymentOptions[i];
                        if (paymentOption.type === visibleOrder.payment_type) {
                            if (paymentOption.type === "sagepay" && visibleOrder.sagepay_token) {
                                if (paymentOption.id === visibleOrder.sagepay_token) {
                                    paymentOptionID = paymentOption.id;
                                }
                            } else {
                                paymentOptionID = paymentOption.id;
                            }
                        }
                    }
                }
                if (!paymentOptionID) {
                    if (accountOption) {
                        paymentOptionID = accountOption.id;
                    } else if (paymentOnDespatchOption) {
                        paymentOptionID = paymentOnDespatchOption.id;
                    }
                }
                viewModel.payment_options = paymentOptions;
                viewModel.payment_option_id = paymentOptionID;

                updatePaymentOption();
            }

            function updatePaymentOption() {

                const paymentOptionID = viewModel.payment_option_id;

                if (!paymentOptionID || definedPaymentOptionIDs.includes(paymentOptionID)) {
                    delete visibleOrder.sagepay_token;
                    if (paymentOptionID !== "sagepay") {
                        visibleOrder.sagepay_create_token = false;
                    }
                    visibleOrder.payment_type = paymentOptionID;
                    visibleOrder.confirm_delete_sagepay_token_id = null;
                } else {
                    visibleOrder.sagepay_token = paymentOptionID;
                    visibleOrder.payment_type = 'sagepay';
                }

                if (visibleOrder.confirm_delete_sagepay_token_id && visibleOrder.confirm_delete_sagepay_token_id !== visibleOrder.sagepay_token) {
                    visibleOrder.confirm_delete_sagepay_token_id = null;
                }

                viewModel.can_submit_card = false;
                viewModel.can_submit_account = false;
                if (!$rootScope.model.staff.is_rep) {
                    if (visibleOrder.payment_type === 'account' || visibleOrder.payment_type === 'foc' || visibleOrder.payment_type === 'payment_on_despatch') {
                        if (!customerData.on_hold) {
                            viewModel.can_submit_account = true;
                        }
                    } else {
                        viewModel.can_submit_card = true;
                    }
                }
                viewModel.can_submit_order = viewModel.can_submit_card || viewModel.can_submit_account;
            }

            $scope.onDeliveryTypeChange = function () {
                updateDeliveryType();
                $scope.saveOrder();
            };

            $scope.onLeadTimeOptionChange = function () {
                updateLeadTimeOption();
                $scope.saveOrder();
            };


            $scope.onLeadTimeDateChange = function () {
                updateLeadTimeOption();
                $scope.saveOrder();
            }

            $scope.onPaymentOptionChange = function () {
                updatePaymentOption();
                $scope.saveOrder();
            };

            $scope.twoPersonDeliveryCost = function () {
                let cost = 0;
                const deliveryLines = visibleOrder._lines ?? [];
                for(let deliveryLine of deliveryLines) {
                    const productCode = (deliveryLine.product_code ?? "").toUpperCase();
                    if(productCode.startsWith("PR2MAN")) {
                        cost += parseFloat(deliveryLine._price ?? 0);
                    }
                }
                return cost;
            };

            $scope.deleteSagepayToken = function (sagepayTokenID) {
                const sagepayToken = userData.sagepay_tokens[sagepayTokenID];
                if (!sagepayToken) {
                    return;
                }
                $rootScope.service.account.deleteSagepayToken(sagepayTokenID, function (success, data, messages) {

                    let paymentOptionAlerts;
                    if (success) {
                        paymentOptionAlerts = siteHelper.addSuccessMessage(
                            "Card Deleted: " + sagepayToken.card_type + " *" + sagepayToken.last_four_digits + " expires " + sagepayToken.expiry_date + " " + sagepayToken.id
                        );
                        viewModel.confirm_delete_sagepay_token_id = null;
                    } else {
                        paymentOptionAlerts = messages && messages.length > 0 ? messages : siteHelper.addErrorMessage(
                            "Unable to delete card"
                        );
                    }
                    viewModel.small_alerts.payment_option = paymentOptionAlerts;
                    populateCheckout();
                });
            };

            $scope.nextAvailableDespatchDate = function () {
                let requiredLeadTimeDays = 0;
                const despatchGroups = visibleOrder._despatch_groups;
                if (despatchGroups) {
                    for (let i = 0; i < despatchGroups.length; i++) {
                        const despatchGroup = despatchGroups[i];
                        const leadTime = parseInt(despatchGroup.lead_time);
                        if (leadTime && leadTime > requiredLeadTimeDays) {
                            requiredLeadTimeDays = leadTime;
                        }
                    }
                }

                const date = new Date();
                while (true) {
                    if (!$scope.isDespatchDateDisabled(date)) {
                        if (requiredLeadTimeDays === 0) {
                            break;
                        }
                        requiredLeadTimeDays--;
                    }
                    date.setDate(date.getDate() + 1);
                }
                return date;
            }


            $scope.getDisabledDespatchDates = function () {
                const holidays = $rootScope.model.cache_local_server.holidays;
                const dates = [];
                if (holidays) {
                    for (let i = 0; i < holidays.length; i++) {
                        const holiday = holidays[i];
                        const tags = holiday.tags;
                        let despatchLocationMatch = tags.length === 0;
                        for (let j = 0; j < tags.length; j++) {
                            if (viewModel.despatch_location_ids.indexOf(tags[j]) !== -1) {
                                despatchLocationMatch = true;
                                break;
                            }
                        }
                        if (!despatchLocationMatch) {
                            continue;
                        }

                        const starts = new Date(holiday.starts.getTime());
                        const ends = new Date(holiday.ends.getTime());

                        starts.setHours(0, 0, 0, 0);
                        ends.setHours(0, 0, 0, 0);

                        const oneDay = 60 * 60 * 24 * 1000;
                        let nextDate = new Date(starts.getTime() - oneDay);
                        while (nextDate < ends) {
                            nextDate = new Date(nextDate.getTime() + oneDay);
                            dates.push(nextDate);
                        }
                    }
                }
                return dates;
            }

            $scope.isDespatchDateDisabled = function (date) {
                date = new Date(date.getTime());
                date.setHours(0, 0, 0, 0);
                const day = date.getDay();
                if (day === 0 || day === 6) {
                    return true;
                }
                const disabledDespatchDates = $scope.getDisabledDespatchDates();
                for (let i = 0; i < disabledDespatchDates.length; i++) {
                    const disabledDespatchDate = disabledDespatchDates[i];
                    if (disabledDespatchDate.getTime() === date.getTime()) {
                        return true;
                    }
                }
                return false;

            }

            $scope.getDeliveryAddress = function () {
                visibleOrder.delivery_address = siteHelper.requireObject(visibleOrder.delivery_address);
                return visibleOrder.delivery_address;
            }

            $scope.getInvoiceAddress = function () {
                visibleOrder.invoice_address = siteHelper.requireObject(visibleOrder.invoice_address);
                return visibleOrder.invoice_address;
            }

            $scope.checkDeliveryTypeAvailability = function () {
                updateDeliveryType();
            }

            function getPreparedOrder() {

                if(viewModel.payment_option_id !== 'staff'){
                    delete visibleOrder.payment_mark_paid;
                }

                return JSON.parse(JSON.stringify(visibleOrder));
            }

            $scope.saveOrder = function (callback) {

                siteHelper.resetObject(viewModel.small_alerts);
                const preparedOrder = getPreparedOrder();
                $rootScope.service.order.saveOrder(preparedOrder, function (success, order, messages) {
                    validateOrder(order);
                    if (!visibleOrder) {
                        return;
                    }
                    populateCheckout();
                    if (callback) {
                        callback(success, order, messages)
                    }
                });
            };

            $scope.getVisibleOrder = function () {
                return $scope.visible_order;
            }


            $scope.submitAddress = function (validateFormCallback) {
                $scope.saveOrder(function (success, order, messages) {

                    const deliveryAddressError = order._errors && order._errors.delivery_address ? order._errors.delivery_address : null;
                    messages = deliveryAddressError ? siteHelper.addErrorMessage(deliveryAddressError) : [];
                    success = !messages.length;
                    validateFormCallback(success, messages);
                    if (success) {
                        $state.go('myba.order-checkout');
                    }
                })
            }

            $scope.submitOrder = function (validateFormCallback) {

                siteHelper.resetObject(viewModel.small_alerts);
                const preparedOrder = getPreparedOrder();
                preparedOrder.response_url = 'https://' + $location.host() + $state.href("myba.order-checkout-processing.entry", {order_id: preparedOrder._id});

                $scope.form_disabled = true;
                $rootScope.service.order.submitOrder(preparedOrder, function (success, order, messages) {
                    if (success) {

                        if (order._status == "SAGEPAY") {
                            window.location = order._redirect_url;
                        } else {

                            $rootScope.service.tracking.track_sale(order);
                            $rootScope.service.order.startNewOrder();
                            // redirect to the acknowledgement page
                            $state.go('myba.order-checkout-acknowledgement.entry', {order_id: order._id});

                        }
                    } else {
                        $scope.did_submit = false;
                        $scope.form_disabled = false;
                    }
                    validateCheckoutState(order);
                    if ($scope.checkout_state_id !== "submit") {
                        messages = [];
                    }
                    validateFormCallback(success, messages);
                });

            };

            $scope.saveForLater = function () {
                viewModel.form_disabled = true;
                $scope.saveOrder(function () {
                    viewModel.form_disabled = false;
                    $rootScope.service.order.startNewOrder();
                    $state.go('myba.dashboard');
                });

            };

            $scope.validateReference = function () {
                $rootScope.service.order_helper.validateReference(visibleOrder)
            };


            $scope.removeCartLine = function (index) {
                visibleOrder.lines.splice(index, 1);
                $scope.saveOrder();
            };

            $scope.getAddresses = function () {
                return !$rootScope.model.staff.is_staff_or_rep ? userData.addresses : customerData.addresses;
            }

            $scope.anchorScroll = function (hash) {
                $location.hash(hash);
                $anchorScroll();
            };

            $scope.totalCarriage = function (despatchGroup) {
                let price = despatchGroup.carriage_price;
                if (visibleOrder._lines) {
                    for (let i = 0; i < visibleOrder._lines.length; i++) {
                        price += visibleOrder._lines[i]._price;
                    }
                }
                return price;
            };

        }]);